import { mapParamsBySchema, mapRowsBySchema } from '../../../util';
import Global from '../../../Services/Common/Global';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';
import { M_NOT_BASIC_01_Schema } from './M_NOT_BASIC_01_Schema';
import useDeleteMutation from './../../../Hooks/apis/useDeleteMutaion';

export const useSearch1 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_01_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.Notice.getNotBasic01R1, params);
  }, successOptions);
};
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_01_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.Notice.getNotBasicR2, params);
  }, successOptions);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_NOT_BASIC_01_Schema.mapper.delete1);
    return apiRequest('post1', Global.urls.Notice.deleteNotBasicD2, payload);
  }, options);
};
